import type {
  CreateParticipantRequest,
  UpdateParticipantRequest,
} from "src/core/backend/clients/backendClient";
import { backendService } from "../../../core/backend/services/backendService";

class ParticipantService {
  public participantList() {
    return backendService.createBackendClient().apiParticipantListByUser();
  }

  public participantPost(request: CreateParticipantRequest) {
    return backendService.createBackendClient().apiParticipantPost(request);
  }

  public participantPut(request: UpdateParticipantRequest) {
    return backendService.createBackendClient().apiParticipantPut(request);
  }

  public participantDelete(id: number) {
    return backendService.createBackendClient().apiParticipantDelete(id);
  }
}

export const participantService = new ParticipantService();
